export const clearSlugForSearchResultUrl = (dirtySlug: string): string => {
  return dirtySlug.replace('/', '')
}
